<template>
  <div class="chat-container">
    <digital-event-preloader type="container" :active="loading" />
    <div v-if="!loading" class="room-chat chat">
      <div v-if="isUserPublic" class="room-chat-info">
        <div class="chat-help">
          <div class="help-ico"><i class="fa fa-info-circle" aria-hidden="true"></i></div>
          <div class="help-info">
            <ul>
              <li>As a member of the public gallery chat is disabled.</li>
              <li>Log in with your company email to join a {{ groupTerminology.toLowerCase() }}.</li>
            </ul>
          </div>
        </div>
      </div>
      <ul :id="'group-' + group.uuid + '-messages'" class="stream list-group list-group-flush" ref="messagesRoom">
        <li v-if="canLoadMoreMessages" class="text-center">
          <!-- eslint-disable max-len -->
          <a href="javascript:void(0);" class="msg-load-more" @click="loadMoreMessages"
            ><i class="fa fa-chevron-up" aria-hidden="true"></i><span> read more </span
            ><i class="fa fa-chevron-up" aria-hidden="true"></i
          ></a>
        </li>
        <chat-message
          v-for="(message, index) in exposedMessages"
          :key="'roomMessage-' + index"
          :message="message"
          type="ROOM"
        ></chat-message>
      </ul>
      <div
        v-if="currentUser && !isUserPublic && !currentUser.isBanned"
        :id="group.uuid + '-new-message'"
        class="message-new"
      >
        <chat-input
          v-model="message"
          placeholder="public message to the room..."
          :group="group"
          @send-message="sendMessage()"
          @emoji-picked="emojiPicked($event)"
        ></chat-input>
      </div>
      <div v-else-if="currentUser && currentUser.isBanned && !isUserPublic">
        <p class="banned-message">
          You have been banned from sending messages to the room. To contact an event admin click
          <a href="javascript:void(0);" @click="sendPrivate()">here</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ChatMixin from "@/components/DigitalEvent/RoomList/Room/mixins/ChatMixin";
import ChatInput from "@/components/DigitalEvent/RoomList/Room/Chat/components/ChatInput";
import { TABLE_TYPES, WSS_MESSAGE_TYPES } from "@/helpers/constants";
import { scrollToTheBottom } from "@/helpers/DOMHelper";
import { mapGetters } from "vuex";

export default {
  name: "RoomMessages",
  props: {
    loading: {
      type: Boolean
    }
  },
  mixins: [ChatMixin],
  components: {
    "chat-input": ChatInput
  },
  data() {
    return {
      action: "socket/sendToRoom"
    };
  },
  computed: {
    ...mapGetters({
      group: "room/activeRoom",
      currentUserTable: "tables/userTable",
      currentUser: "users/currentUser",
      getUser: "users/getUser",
      groupTerminology: "room/groupTerminology"
    }),
    messages() {
      return this.$store.getters["chat/roomMessages"];
    },
    isUserPublic() {
      return this.currentUserTable.TABLE_TYPE === TABLE_TYPES.PUBLIC_GALLERY;
    }
  },
  methods: {
    /**
     * Send message to room
     */
    sendMessage() {
      if (!this.canSendMessage) {
        return;
      }
      this.$store.dispatch(this.action, {
        message: {
          text: this.message,
          type: WSS_MESSAGE_TYPES.ROOM_MESSAGE
        }
      });

      this.message = "";
    },
    sendPrivate() {
      let bannedBy = this.getUser(this.currentUser.bannedBy);
      this.sendPrivateMessage(bannedBy);
    }
  },
  created() {
    this.unwatchMessages = this.$watch("messages", () => {
      scrollToTheBottom(`group-${this.group.uuid}-messages`);
      this.unwatchMessages();
    });
  }
};
</script>

<style scoped>
.banned-message {
  font-size: 12px;
  color: #777777;
  text-align: center;
}
</style>
